import React, { useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { PickerComponent, ComponentController } from 'components/common';
import { Datasource } from 'Api';
import { PayeeFormNames } from './Helpers';

const CountryLookup = ({
  countryFieldName, payeeDetailsState, setPayeeDetailsState, abortController,
  setAbortController, control, forceClearDatasourceState, setForceClearDatasourceState,
  errors, getRequiredError, setBannerState, setValue, resetField, setLoading }) => {
  const onCountryChange = useCallback(
    (value, name) => {
      let country = value?.shortNameNoAccent ?? '';
      let countryIso2 = value?.iso2Code ?? '';
      let countryId = value?.id ?? null;
      let subdivisions = value?.subdivisions;

      resetField('payee');
      resetField('stateOfIncorporation');
      resetField('stateOfResidency');

      setForceClearDatasourceState({
        "payee": true,
        "stateOfIncorporation": true,
        "stateOfResidencyCode": true
      });

      setPayeeDetailsState((previous) => {
        return {
          ...previous,
          [name]: country,
          [`${name}Iso2`]: countryIso2,
          [`${name}Id`]: countryId,
          payee: '',
          payeeDetails: null,
          subdivisions: subdivisions,
          stateOfIncorporation: '',
          stateOfIncorporationCode: '',
          stateOfResidency: '',
          stateOfResidencyCode: '',
          orbisId: '',
          hamiltonId: '',
          source: '',
          givenName: '',
          familyName: ''
        };
      });

      abortController.abort();
    },
    [setPayeeDetailsState, abortController, resetField, setForceClearDatasourceState],
  );

  const renderCountry = () => {
    if (!payeeDetailsState.payeeType) {
      return <></>;
    }
    const name = countryFieldName;

    return (
      <Grid item>
        <ComponentController
          name={name}
          control={control}
          required={true}
          render={({ field: { name, onBlur, onChange } }) => (
            <PickerComponent
              label={PayeeFormNames[name]}
              fieldName={name}
              value={payeeDetailsState[name]}
              config={{ showAddOptionIfNoData: false }}
              datasource={Datasource.countries}
              forceClearDatasource={forceClearDatasourceState}
              abortController={abortController}
              error={!!errors[name]}
              errorText={getRequiredError(name, PayeeFormNames[name])}
              setBannerState={setBannerState}
              setValidationValue={setValue}
              setLoading={setLoading}
              setFormState={setPayeeDetailsState}
              setAbortController={setAbortController}
              onChange={(value) => {
                onCountryChange(value, name);
                onChange(value);
              }}
              onBlur={onBlur}
              OptionsHeader={({ className }) => {
                return (
                  <Grid container direction="row" spacing={0} className={className}>
                    <Grid item xs={9}><div>Country</div></Grid>
                    <Grid item xs={3}><div>Country Code</div></Grid>
                  </Grid>
                );
              }}
              OptionView={({ option, className }) => {
                return (
                  <Grid container direction="row" spacing={0} className={className}>
                    <Grid item xs={9}><div>{option.shortNameNoAccent}</div></Grid>
                    <Grid item xs={3}><div>{option.iso2Code}</div></Grid>
                  </Grid>
                );
              }}
            />
          )}
        />
      </Grid>
    );
  };

  return (
    <>{renderCountry()}</>
  );
}

export default CountryLookup;
